<template>
	<div class="profile">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>{{detail.title}}</span>
			<div></div>
		</div>
		<!-- 介绍内容 -->
		<div class="content" ref="richText" v-html='detail.content'></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail: []
			}
		},
		created() {
			let that = this,
				id = that.$route.query.id;
			//关于我们
			that.$axios.post(baseUrl + '/mobile/Base/aboutInfo', {
				id: id
			}).then(function(res) {
				if (res.data.code == 2) {
					that.detail = res.data.data;

				}
			}).catch(function(err) {
				console.log(err);
			});
		}
	}
</script>

<style scoped>
	@import "profile.css";
	
	.content >>> img {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/about/profile.vue